import {getData, postData, postDataWithSession} from '.';

import { API_URL } from '../config';
import {API_ENDPOINTS} from "../constants";

export const getUsers = (queryParams) => {
  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.GET_USERS}`, {}, true);
};

export const fetchProfile = (queryParams, myUser) => {

  const options = {
    body: JSON.stringify(myUser)
  }
  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.GET_USER_PROFILE}`, options);
}

export const saveProfile = (queryParams, profile) => {
  const options = {
    body: JSON.stringify(profile)
  }

  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.UPDATE_USER_PROFILE}`, options);
}

export const createUser = (queryParams, profile) => {
  const options = {
    body: JSON.stringify(profile)
  }

  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.CREATE_USER}`, options);
}

export const createUserPermissions = (queryParams, userCompositeObject) => {
  const options = {
    body: JSON.stringify(userCompositeObject)
  }

  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.CREATE_USER_PERMISSIONS}`, options);
}

export const addUserSchools = (queryParams, schools) => {
  const options = {
    body: JSON.stringify(schools)
  }

  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.ADD_USER_SCHOOLS}`, options);
}

export const removeUserSchools = (queryParams, schools) => {
  const options = {
    body: JSON.stringify(schools)
  }

  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.REMOVE_USER_SCHOOLS}`, options);
}

export const addUserDistricts = (queryParams, districts) => {
  const options = {
    body: JSON.stringify(districts)
  }

  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.ADD_USER_DISTRICTS}`, options);
}

export const removeUserDistricts = (queryParams, districts) => {
  const options = {
    body: JSON.stringify(districts)
  }

  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.REMOVE_USER_DISTRICTS}`, options);
}

export const updatePermissionLevel = (queryParams, userPermissionObject) => {
  const options = {
    body: JSON.stringify(userPermissionObject)
  }

  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.UPDATE_USER_PERMISSIONS}`, options);
}

export const setUserLocked = (queryParams) => {
  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.LOCK_USER}`, {});
}

export const getPermissionList = (queryParams) => {
  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.GET_PERMISSIONS_LIST}`, {}, true);
}

export const sendInvite = async (queryParams) => {
  const params = new URLSearchParams(queryParams);

  return await postData(`${API_URL}/auth/inviteUser?${params}`, {});
}